import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const Button = ({
  children, disabled, loading, onClick,
}) => (
  <button
    className={`button ${disabled ? 'button--disabled' : ''} ${loading ? 'button--loading' : ''}`}
    type="button"
    disabled={disabled}
    onClick={onClick}
  >
    <div className="button__inner">
      {
        !loading && (
          children
        )
      }
    </div>
  </button>
);

export default Button;

Button.defaultProps = {
  disabled: false,
  loading: false,
  onClick: null,
};


Button.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
};
